import VendorAccountView from './containers/VendorAccountView';
import React from 'react';
export default VendorAccountView;

export {uiDataVendorAccountView , serverDataVendorAccountView} from './reducers/VendorAccountView';